import React from "react";
import "./checkbox.css";

function Chackbox({
  className,
  children,
  linked,
  name,
  primary,
  checked,
  secondary,
  onChange,
  changeable
}) {
  if (changeable === undefined) changeable = true;
  
  //   let btnClass = secondary ? "checkbox-secondary" : "btn-primary";
  let classes = ["checkbox-primary", className].join(" ");
  let labelElement = children ? (
    <span className="label">{children}</span>
  ) : null;
  let _onChange = undefined;

  if (linked) {
    _onChange = e => {
      [...document.querySelectorAll(`.checkbox-primary input[name="${name}"]`)]
        .filter(item => item !== e.target)
        .forEach(item => (item.checked = false));
    };
  }

  function handleOnChange(e) {
    if (_onChange) _onChange(e);
    if (onChange) onChange(e);
  }

  function labelClicked(e) {
    if(!changeable) {e.preventDefault(); e.stopPropagation(); return false;}
  }

  return (
    <label className={classes} onClick={labelClicked}>
      <input
        type="checkbox"
        name={name}
        defaultChecked={checked}
        onChange={handleOnChange}
      />
      <span className="checkmark"></span>
      {labelElement}
    </label>
  );
}

export default Chackbox;
